import classNames from 'classnames'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { getCalendarGridTimeRangeLabel } from '../CalendarGrid.utils'

import { QA_NAME_CALENDAR_GRID_CHIP } from './CalendarGridChip.constants'

import * as styles from './CalendarGridChip.module.css'

function CalendarGridChip({
  className = styles.CalendarGridChip,
  elementRef,
  item = EMPTY_OBJECT,
  onClick,
  onClickItem,
  ...restProps
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    end,
    hint,
    id,
    isAllDay,
    isDisabled,
    start,
    title,
    tooltip,
    variant,
  } = item

  function handleClick(event) {
    onClick?.(event)

    onClickItem?.(item, event)
  }

  return (
    <FloatingTooltip
      content={tooltip ?? hint}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <div
        {...restProps}
        {...getQaSelector({ context: id, value: QA_NAME_CALENDAR_GRID_CHIP })}
        className={classNames(className, styles[variant], {
          [styles.disabled]: isDisabled,
        })}
        ref={elementRef}
        onClick={handleClick}
      >
        {isAllDay ? null : (
          <Text className={styles.time}>
            {getCalendarGridTimeRangeLabel({ end, locale, start, timezone })}
          </Text>
        )}
        <Text className={styles.title}>{title}</Text>
      </div>
    </FloatingTooltip>
  )
}

export default CalendarGridChip
